<form name="frmFeedbackSugstn" >
    <div class="container panel panel-default col-md-offset-1 col-md-10" style="padding-left:0%;padding-right:0%;border-color:black;height:35vw;">
        <div class="panel panel-heading" style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.9%; color: white;" *ngIf="fbsn!='Feedback' && fbsn!='Suggestions'">Feedback/Suggestions</div>
        <div class="panel panel-heading" style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.6%; color: white;" *ngIf="fbsn=='Feedback' || fbsn=='Suggestions'">{{fbsn}}</div>
        <div class="panel-body">
            <!-- <div class="activity-box"><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load" /></div></div> -->
            <div class="form-group row">
                <div class="col-md-4">
                    <label class="radio-inline" style="font-size: 14px">
                        <input type="radio" name="rdfeedback" value="Feedback" [(ngModel)]="fbsn" (change)="ChangeType($event.target.value)" [checked]="IsFeedback"> Feedback
                    </label>
                    <label class="radio-inline" style="font-size: 14px">
                        <input type="radio" name="rdSuggestions" value="Suggestions" [(ngModel)]="fbsn" (change)="ChangeType($event.target.value)" [checked]= "IsSuggestions"> Suggestions
                    </label>
                </div>
            </div>
            <div class="col-lg-12">
                <div *ngIf="fbsn=='Feedback' || fbsn=='Suggestions'">
                    <div class="form-group row">
                        <div class="col-sm-4 formDivCaptions">
                            <label for="txtSubmittedBy">User Name</label>
                            <input type="text" class="form-control" id="txtSubmittedBy" name="txtSubmittedBy" [(ngModel)]="SubmittedBy" disabled>
                        </div>

                        <div class="col-sm-4 formDivCaptions">
                            <label for="txtDateSubmitted">Submitted Date</label>
                            <input type="text" class="form-control" id="txtDateSubmitted" name="txtDateSubmitted" [(ngModel)]="DateSubmitted" disabled>
                        </div>
    
                        <div class="col-sm-4 formDivCaptions">
                            <label for="txtCountry">Country</label>
                            <input type="text" class="form-control" id="txtCountry" name="txtCountry" [(ngModel)]="Country" disabled>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="fbsn=='Feedback'">
                        <div class="col-sm-4 formDivCaptions">
                            <label for="SuggestionFeedback">Feedback</label>
                        </div>
                        <div class="col-sm-6 ">
                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                <span *ngIf="!txtfeedback.valid">*</span>
                            </div>
                            <textarea class="form-control" id="SuggestionFeedback" name="txtfeedback" [(ngModel)]="SuggestionFeedback" #txtfeedback="ngModel" maxlength="200" style="height:120px" required></textarea>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="fbsn=='Suggestions'">
                        <div class="col-sm-4 formDivCaptions">
                            <label for="SuggestionFeedback">Suggestions</label>
                        </div>
                        <div class="col-sm-6 ">
                            <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                <span *ngIf="!txtAreaSuggestion.valid">*</span>
                            </div>
                            <textarea class="form-control" name="txtAreaSuggestion" id="txtAreaSuggestion" [(ngModel)]="SuggestionFeedback" #txtAreaSuggestion="ngModel"  maxlength="1000" aria-label="txtAreaSuggestion" style="height:120px" required></textarea>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <div align="center" *ngIf="fbsn=='Feedback' || fbsn=='Suggestions'">
                    <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="submitFbsnData()"><span class="fa fa-check-circle" aria-hidden="true"></span> Submit</button>&nbsp;
                    <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="Clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>
                </div>
            </div>
        </div>
    </div>
</form>